module.exports = __webpack_public_path__ + "img/cancavsbtn.dffa117e.png";